import {NgModule} from '@angular/core';
import {GlobalSettingsApiService} from './services/global-settings-api';

@NgModule({
    providers: [
        GlobalSettingsApiService
    ]
})
export class AppEnvSpecificModule {}
